import PropTypes from 'prop-types';

export const inputValueType = PropTypes.oneOfType([PropTypes.string, PropTypes.number]);

export const inputRadioButtonValueType = PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]);
